@if (canBeVisible()) {
  <mat-toolbar class="mb-2.5 flex items-center justify-between px-2.5">
    <img id="toolbar__logo" alt="Logo" src="assets/icons/toolbar.png" class="flex-1" />
    <span id="toolbar__name" class="flex-[2] text-white">Pujasweb {{ auctionName() }}</span>
    <span id="toolbar__toggle" class="border-r-2 border-white h-[90%] flex-1"></span>
    <div id="toolbar__chat-wrapper" class="flex-1 text-center">
      <mat-icon svgIcon="app-whatsapp" (click)="openChat()" (keydown.enter)="openChat()" tabindex="0" class="w-7.5! h-7.5!"></mat-icon>
    </div>
  </mat-toolbar>
}
